import { UMCRecordController } from '../umc-record.controller';
import type { UMCRecordType } from '../umc-record.controller';

export class UMCRecordVideoController extends UMCRecordController {
	protected getType (): UMCRecordType {
		return 'video';
	}
}
